module.exports = __webpack_public_path__ + "static/media/DentalImage.5cc5af1c.jpg";